import PageMeta from '@/components/feature/PageMeta';
import HeroSection from './components/HeroSection';
import FeaturedNovels from './components/FeaturedNovels';
import CategoryNav from './components/CategoryNav';
import RankingSection from './components/RankingSection';
import LatestArticles from './components/LatestArticles';

const homepageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '嫂子的诱惑 - 都市禁忌情感小说精选推荐',
  description: '探索「嫂子的诱惑」系列都市情感故事，汇聚热门网络小说、影视改编作品与情感解析内容。深度剖析禁忌情感叙事结构，为言情小说爱好者提供最全面的作品导读与推荐榜单。',
  url: 'https://cbdti.cn/',
  isPartOf: {
    '@type': 'WebSite',
    name: '嫂子的诱惑',
    url: 'https://cbdti.cn/',
  },
  about: {
    '@type': 'Thing',
    name: '都市禁忌情感小说',
    description: '汇聚热门网络小说、影视改编作品与情感解析内容',
  },
};

export default function Home() {
  return (
    <PageMeta
      title="嫂子的诱惑 - 都市禁忌情感小说精选推荐 | 热门言情网文导读"
      description="探索「嫂子的诱惑」系列都市情感故事，汇聚热门网络小说、影视改编作品与情感解析内容。深度剖析禁忌情感叙事结构，为言情小说爱好者提供最全面的作品导读与推荐榜单。"
      keywords="嫂子的诱惑,都市禁忌情感小说,言情网络小说推荐,禁忌爱情故事,热门都市小说榜单,情感叙事解析,网文推荐"
      canonicalUrl="https://cbdti.cn/"
      ogTitle="嫂子的诱惑 - 都市禁忌情感小说精选推荐"
      ogDescription="探索「嫂子的诱惑」系列都市情感故事，汇聚热门网络小说、影视改编作品与情感解析内容。"
      ogType="website"
      ogUrl="https://cbdti.cn/"
      twitterCard="summary_large_image"
      jsonLd={homepageSchema}
    >
      <main>
        <HeroSection />
        <FeaturedNovels />
        <CategoryNav />
        <RankingSection />
        <LatestArticles />
      </main>
    </PageMeta>
  );
}